import React from 'react'

import { withContext, WithContextProps } from 'admin/components/common/withContext'
import { default as AlertComponent, AlertProps } from 'components/ui/Alert'

/**
 * Alert wrapper for translating alert messages before display
 */
const Alert: React.FunctionComponent<AlertProps & WithContextProps> = props => {
  let { locale, alert, ...otherProps } = props
  if (alert) {
    if (typeof alert === 'string') {
      alert = locale.translate(alert.startsWith('alert.') ? alert : `alert.${  alert}`)
    } else if ('message' in alert && typeof alert.message === 'string') {

      alert = {
        ...alert,
        message: locale.translate(
          alert.message.startsWith('alert.') ? alert.message : `alert.${alert.message}`
        ),
      }
    }
  }

  return <AlertComponent alert={alert} {...otherProps} />
}

export default withContext(Alert)